import { Portal } from '@angular/cdk/portal';
import { Injectable, inject, signal } from '@angular/core';
import { FileMetadata } from '@lib/models/generated/graphql';
import { OuiSlidePanelService } from 'omnium-ui/layout';
import { filter, map, Observable, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SignaturePanelService {
  private slidePanelService = inject(OuiSlidePanelService);
  private signatairePortal: Portal<any> | null = null;
  public files = signal<FileMetadata[]>([]);
  public readonly viewerClosed$: Observable<void>;
  private opened = false;

  constructor() {
    this.viewerClosed$ = this.slidePanelService.slidePanelState$.pipe(
      filter(state => state === 'closed' && this.opened),
      tap(() => {
        this.opened = false;
        this.files.set([]);
      }),
      map(() => void 0)
    );
  }

  public registerPortal(portal: Portal<any>): void {
    this.signatairePortal = portal;
  }

  public closePanel(): void {
    this.slidePanelService.setSlidePanelContent(null);
    this.slidePanelService.closeSlidePanel();
  }

  public openSignataireViewer(files: FileMetadata[]): void {
    this.files.set(files);
    this.slidePanelService.setSlidePanelContent(this.signatairePortal);
    this.slidePanelService.openSlidePanel({ position: 'right', autoFocus: false, disableClose: false });
  }
}
